module.exports = __webpack_public_path__ + "static/img/er.23ead39.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/er.png
// module id = hM+h
// module chunks = 1